import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  Body,
  BodyBold,
} from 'ggx-componentlibrary/design/typography/typography.styles'

import { RouteInfo } from './route-info/route-info.component'
import { DriverNotesContainer } from './shipping-info.component.styles'
import { orderService } from '../../../van-booking/api/order-api.service'
import { getLocale } from 'ggx-src/legacy/utils/locale'
import BET_3866 from 'ggx-src/feat/BET_3866'

const ShippingInfo = ({ order, orderContactInfo }) => {
  const [t] = useTranslation()

  const remarks = order.order_request_detail?.remark
  const NotesToDriver = (
    <DriverNotesContainer>
      <BodyBold noMargin style={{ marginBottom: '12px' }}>
        {t('common__notes_to_driver')}
      </BodyBold>
      <Body noMargin style={{ 'line-break': 'anywhere' }}>
        {remarks}
      </Body>
    </DriverNotesContainer>
  )
  const internalNotes = order.order_request_extra?.internal_notes
  const MerchantOrderNote = (
    <DriverNotesContainer>
      <BodyBold noMargin style={{ marginBottom: '12px' }}>
        {t('merchant_order_note')}
      </BodyBold>
      <Body noMargin style={{ 'line-break': 'anywhere' }}>
        {internalNotes}
      </Body>
    </DriverNotesContainer>
  )

  const [printing, setPrinting] = useState(false)
  const iframeRef = useRef()
  const handlePrint = async () => {
    if (iframeRef.current) {
      setPrinting(true)
      const { data } = await orderService.downloadOrderPDF(
        order.id,
        getLocale() === 'zh-hk' ? 'zh_hk' : 'en'
      )
      const blob = new Blob([data], { type: 'application/pdf' })
      const fileURL = window.URL.createObjectURL(blob)
      const timeId = setTimeout(() => setPrinting(false), 10000)
      iframeRef.current.onload = function() {
        this.contentWindow.print()
        setPrinting(false)
        clearTimeout(timeId)
      }
      iframeRef.current.src = fileURL
    }
  }

  return (
    <div>
      <BodyBold style={{ marginBottom: '12px' }}>{t('common__route')}</BodyBold>
      <RouteInfo
        waypoints={order.waypoints}
        pickupTime={order.pickup_time}
        orderContactInfo={orderContactInfo}
      />
      <BET_3866.PackageContentBlockInDetail
        packageContent={order?.order_request_extra?.package_content}
      />
      {remarks && NotesToDriver}
      {internalNotes && MerchantOrderNote}
    </div>
  )
}

ShippingInfo.propTypes = {
  order: PropTypes.shape({
    waypoints: PropTypes.arrayOf(PropTypes.object),
  }),
  breakdownResponse: PropTypes.object,
}

ShippingInfo.defaultProps = {
  order: {},
}

export { ShippingInfo }
